import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, DatePicker, StyledMaxWidth } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys, patientTranslationKeys } from '../../translations';

type EffectiveDateFieldProps = FieldControllerProps<'effectiveDate', LocalDate | null> & ClassNameProp;

export const EffectiveDateField = (props: EffectiveDateFieldProps): JSX.Element => {
   const controller = props.register(props.name, { required: true });

   return (
      <StyledMaxWidth maxWidth={172}>
         <DatePicker
            testId={props.name}
            controller={controller}
            label={entitlementStatementsTranslationKeys.createModal.effectiveDate}
            placeholder={patientTranslationKeys.datePlaceholder}
            withNavigationArrows
            dayValidators={'dayAfterToday'}
         />
      </StyledMaxWidth>
   );
};
